import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from './store';

/** Bounces unauthenticated visitors to /login, preserving the requested path. */
export function ProtectedRoute() {
  const token = useAuthStore((s) => s.token);
  const location = useLocation();
  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
